import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { errorsToText } from '@coin/shared/core/util-helpers';
import { PureFunctionPipe } from '@coin/shared/core/util-pipes';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'coin-form-info-message',
  imports: [PureFunctionPipe, MatIcon, TranslateModule],
  templateUrl: './form-info-message.component.html',
  styleUrl: './form-info-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormInfoMessageComponent {
  errors = input<ValidationErrors | string[]>();
  warnings = input<string[]>();
  infos = input<string[]>();
  successes = input<string[]>();

  protected readonly errorsToText = errorsToText;
}
